/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import { Grid, Box } from "@material-ui/core";
import styled from "styled-components";
import { BarChart, ProductCard } from "../components";
import Carousel from "react-material-ui-carousel";

const StyledBestSellers = styled.div`
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0px 0px 6px #0000001a;
  border-radius: 8px;
  padding: 2em;
  .title {
    text-transform: uppercase;
  }
`;

const BestSellers = ({ topProducts }: any) => {
  // Limitar topProducts a los elementos 0, 1 y 2
  const limitedTopProducts = topProducts.slice(0, 3);

  // Función para agrupar las tarjetas en conjuntos de 3
  const chunkArray = (array: any[], chunkSize: number) => {
    const results = [];
    while (array.length) {
      results.push(array.splice(0, chunkSize));
    }
    return results;
  };

  const groupedProducts = chunkArray([...limitedTopProducts], 3);

  return (
    <StyledBestSellers>
      <p className="title">Productos mas vendidos del dia</p>
      {groupedProducts.map((group, idx) => (
        <Box key={idx} display="flex" justifyContent="space-between">
          {group.map((e: any, i: number) => (
            <ProductCard product={e} key={i} />
          ))}
        </Box>
      ))}
    </StyledBestSellers>
  );
};

export default BestSellers;
